import Day from "./Day"
export default Day
